export default __webpack_public_path__ + "static/cdc2-4e275881c674bf6ec84c2ff9f23f1f12.jpg";